import * as React from 'react'
import classNames from 'classnames'

import { HomeAccelerationCardCmsContent } from 'core/services/cms/interfaces'

import { Text, TextName } from '../../../../sdk/text/Text'
import lightningImage from '../../assets/lightning.png'

import classes from './style.module.scss'

interface ComponentProps {
  className?: string
  content: HomeAccelerationCardCmsContent
}

export const ProcessingFeatureCard: React.FC<ComponentProps> = (props) => {
  const { className, content } = props
  const statLines = [
    content.statPrefix,
    content.statValue,
    content.statSuffix,
  ].filter((line): line is string => Boolean(line))

  return (
    <div className={classNames(classes.container, className)}>
      <Text type={TextName.H1} className={`${classes.gradientText} ${classes.h1Text}`}>
        {statLines.map((line, index) => (
          <React.Fragment key={`${line}-${index}`}>
            {index > 0 ? <br /> : null}
            {line}
          </React.Fragment>
        ))}
      </Text>
      <Text type={TextName.Text} className={classes.bodyText}>
        {content.body}
      </Text>
      <img src={content.iconUrl || lightningImage} alt='' className={classes.lightningImage} />
    </div>
  )
}
